import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=6bbfc0df&"
import script from "./authLayout.vue?vue&type=script&lang=js&"
export * from "./authLayout.vue?vue&type=script&lang=js&"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=6bbfc0df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports